// Compact LAM-style legend, displayed only up to 300 mm.
// Both use the same registry as the actual station markers and rain field.
export function dailyRainLegend(def) {
    const number = value => String(value).replace('.', ',');
    const colorAt = index => def.colors[Math.min(index + 1, def.colors.length - 1)];
    const levels = def.breaks.filter(value => value <= 300);
    return {
        bands: levels.slice(0, -1).map((v, i) => ({
            color: colorAt(i), label: `${number(v)}–${number(levels[i + 1])}`,
        })),
        ticks: levels.map((v, i) => ({pos: i / (levels.length - 1), row: i % 2, label: number(v)})),
    };
}
